import React from "react";
import Skeleton from "react-loading-skeleton";
import { Grid } from "@material-ui/core";

export default function SkeletonPaper(row) {
  return (
    <Grid container direction="column">
      {Array(row)
        .fill()
        .map((item, index) => (
          <div key={index}>
            {/* <h2 className="section-title status-title py-4"> */}
            <Skeleton duration={2} height={25} width={`100%`} />
            {/* </h2> */}
            {/* <Skeleton height={`100vh`} /> */}
          </div>
        ))}
    </Grid>

    // <Grid container direction="column">
    //   <Grid item container direction="row">
    //     <div>Scope</div>
    //     <div>-</div>
    //     <div >
    //       <Skeleton duration={2} height={2} width={`100%`} />
    //     </div>
    //   </Grid>
    // </Grid>
  );
}
